import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

// External
import { AngularFireDatabase } from 'angularfire2/database';
import * as lodash from 'lodash';
import { Order } from './../../models/order'
import { ApiService } from 'app/services/api';


@Component({
  selector: 'app-raffle-order-detail',
  templateUrl: './raffle-order-detail.component.html',
  styleUrls: ['./raffle-order-detail.component.scss']
})
export class RaffleOrderDetailComponent implements OnInit {

  public raffleId: string;
  public userId: string;
  public raffle: any;
  public orderData: any;
  public orderId: any;

  constructor(private route: ActivatedRoute, private location: Location,
    private fireDatabase: AngularFireDatabase, private apiService: ApiService) {

       
    }

  async ngOnInit() {
     
    this.raffleId = this.route.snapshot.paramMap.get('raffleId');
    this.userId = this.route.snapshot.paramMap.get('userId');
    this.orderId = this.route.snapshot.paramMap.get('orderId');
    if(!this.raffleId) {
      return;
    }
    
    this.raffle = await this.apiService.object(`/raffles/${this.raffleId}`);
    this.orderData = await this.apiService.object(`/raffles-user-ticket/${this.raffleId}/${this.userId}/orders/${this.orderId}`);
    let payment = await this.apiService.object(`/user-payments/${this.userId}/payments/${this.orderData.paymentId}`);
    let user = await this.apiService.object(`/users/${this.userId}`);
    Object.assign(this.orderData, { payment: payment, user: user });    
  }

  numberWithLeadingZeroes (n)
  {
      if ( n< 10 )
      {
          return ( '000' + n.toString () );
      }
      else if ( n< 100 )
      {
          return ( '00' + n.toString () );
      }
      else if ( n< 1000 )
      {
          return ( '0' + n.toString () );
      }
      else
      {
          return ( n);
      }
  }

}
